import HttpClient from "../../services/HttpClient";
import axios from 'axios';
import {isEpsFormat} from "../../utils/common";


class MediaFileManager {

  constructor(httpClient = null) {
    this.httpClient = httpClient || new HttpClient()
    console.log(this.httpClient)
    this.url = `/medias/files`
  }

  getFileExtn(fileFormat) {

    if (!fileFormat.includes('/')) {
      return fileFormat
    } else if (fileFormat.includes('/')) {
      return fileFormat.split('/')[1]
    }
    const re = /(?:\.([^.]+))?$/
    return fileFormat ? re.exec(fileFormat)[1] : ''
  }

  // getMediaType(fileFormat) {
  //   const extn = this.getFileExtn(fileFormat);
  //
  //   const mediaTypes = {
  //     images: new Set(['jpg', 'jpeg', 'png', 'gif', 'svg', 'tif', 'ico', 'dvu', 'eps']),
  //     videos: new Set(['mp4', 'mov', 'wmv', 'avi', 'flv']),
  //     audios: new Set(['mp3', 'wav', 'ogg']),
  //     files: new Set(['csv', 'zip', 'pdf', 'xls', 'json', 'html'])
  //   };
  //
  //   return Object.entries(mediaTypes).find(([_, extensions]) => extensions.has(extn))?.[0] || null;
  // }


// helper api calls
  async getFileLocation(uuid) {
    try {
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.get(url);
      console.log("res success", res)
      return res
    } catch (e) {
      // instance.handleHasErrors(true)
      // instance.handleErrorMessage(e.message)
      console.log("failed to get mediaFile: ", e.message);
      throw e
    }
  }

   makeAllUserDimension(dimensions) {
    const result = {};
    dimensions.forEach(dimension => {
      result[dimension.uuid] = [];
    });
    return result;
  }

  async createNewLocation(componentState, file, uuid, attempt = 1) {
    // Call getDimensions immediately and store result to avoid passing function to HTTP client
    const dimensionsResult = componentState.getDimensions ? componentState.getDimensions() : null;

    // Extract only serializable data
    const { groupSelectStore, mediaFile, tagSelectStore, isExclusivelyGroupOwned, dimensionsMultiSelectStore } = componentState;

    const fileFormat = isEpsFormat(mediaFile.fileFormat) ? "eps" : mediaFile.fileFormat
    // Modify mediaFile.name if this is not the first attempt
    const baseName = mediaFile.name.replace(/\(\d+\)\.?\w*$/, ''); // Remove any existing (int) suffix
    const newFileName = attempt > 1 ? `${baseName}(${attempt})` : mediaFile.name;
    let dimensions
    if(componentState.dimensionsMultiSelectStore) {
     const dimensionStore = componentState.dimensionsMultiSelectStore.dimensionStore
     if(dimensionStore.dimensionsEnabled) {
       dimensions = {dimensions: componentState.dimensionsMultiSelectStore.getTranspiledDimensions()}
     } else {
       dimensions = {dimensions: this.makeAllUserDimension(dimensionStore.getDimensions())}
     }
    } else {
     console.warn('dimensionsMultiSelectStore not found, defaulting to empty dimensions')
     dimensions = {dimensions: {}}
    }

    try {
      const payload = {
        key: newFileName,
        name: newFileName,
        singleUseFile: !!mediaFile.singleUseFile,
        fileFormat: fileFormat,
        usage: mediaFile.usage,
        tags : tagSelectStore?.selectedTags.flatMap((tag)=>{ return tag.uuid}),
        owner: {"groupUuid":groupSelectStore?.selectedGroup?.uuid,"dimensions": dimensions.dimensions},
        isExclusivelyGroupOwned: isExclusivelyGroupOwned

      };

      const url = `${this.url}`;
      const res = await this.httpClient.post(url, payload);
      console.log("res success", res);
      return res;  // Successful upload
    } catch (e) {
      const errorMessage = e.message || e.response?.data || "";

      if (errorMessage.includes("Resource already exist")) {
        console.log(`Duplicate file name detected, retrying with incremented name... (Attempt ${attempt + 1})`);
        return this.createNewLocation(componentState, file, uuid, attempt + 1);  // Retry with incremented attempt
      }
      console.log("Failed to upload mediaFile:", e.message);
      throw e
    }
  }

  async getS3BucketUrl(uuid) {
    console.log("getS3BucketUrl")
    try {
      const url = `${this.url}/${uuid}/upload`;
      const res = await this.httpClient.post(url);
      console.log("res success", res)
      return res
    } catch (e) {
      // instance.handleHasErrors(true)
      // instance.handleErrorMessage(e.message)
      console.log("failed to get signed url: ", e.message);
      throw e
    }
  }

  async checkMediaFileStatus(uuid) {
    try {
      const res = await this.getFileLocation(uuid);
      console.log("res success", res)
      return res
    } catch (e) {
      console.error("Failed to get mediaFile status", e);
    }
    return null;
  }

  async uploadFile(signedUrl,componentState)  {
    console.log("MediaFileManager:uploadFile")
    try {
      const data = componentState.fileForS3Upload
      const config = {
        headers:{
        'Content-Type': data.type
       },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      }
      const res = await axios.put(signedUrl, data, config);
      console.log("res success", res)
      return "success"
    } catch (e) {
      console.log("failed to upload file: ", e.message);
      throw e
    }
  }

  async updateLocation(componentState) {

    const {mediaFile} = componentState
    const fileFormat = isEpsFormat(mediaFile.fileFormat) ? "eps" : mediaFile.fileFormat
    // const newFileMediaType = this.getMediaType(fileFormat)
    const {groupSelectStore} = componentState
    const {isExclusivelyGroupOwned} = componentState;
    const {tagSelectStore} = componentState
    let dimensions
    if(componentState.dimensionsMultiSelectStore) {
      const dimensionStore = componentState.dimensionsMultiSelectStore.dimensionStore
      if(dimensionStore.dimensionsEnabled) {
        dimensions = {dimensions: componentState.dimensionsMultiSelectStore.getTranspiledDimensions()}
      } else {
        dimensions = {dimensions: this.makeAllUserDimension(dimensionStore.getDimensions())}
      }
    } else {
      console.warn('dimensionsMultiSelectStore not found, defaulting to empty dimensions')
      dimensions = {dimensions: {}}
    }
    // if(newFileMediaType !== mediaFile.mediaType){
    //   throw new Error("Media type cannot be changed")
    // }
    try {
      const payload = {
        key: mediaFile.name,
        name: mediaFile.name,
        status: mediaFile.status,
        fileFormat: fileFormat,
        usage: mediaFile.usage,
        singleUseFile: !!componentState.singleUseFile,
        owner: {"groupUuid":groupSelectStore?.selectedGroup?.uuid, "dimensions":  dimensions?.dimensions},
        tags : tagSelectStore?.selectedTags.flatMap((tag)=>{ return tag.uuid}),
        isExclusivelyGroupOwned: isExclusivelyGroupOwned
      }
      const url = `${this.url}/${mediaFile.uuid}`;
      const res = await this.httpClient.put(url, payload);
      console.log("res success", res)
      return res
    } catch (e) {
      console.log("failed to updateLocation: ", e.message);
      throw e
    }
  }

//need a function that checks if file has completed uploading
  async checkUploadStatus(uuid) {
    try {
      const url = `${this.url}/${uuid}/status`;
      const res = await this.httpClient.get(url);
      console.log("res success", res)
      return res
    } catch (e) {
      // instance.handleHasErrors(true)
      // instance.handleErrorMessage(e.message)
      console.log("failed to get mediaFile: ", e.message);
      throw e
    }
  }

//main functions called on by components
  async getMediaFile(uuid) {
    const fileLocation = await this.getFileLocation(uuid)
    const signedUrl = await this.getS3BucketUrl(uuid)
    return {
      fileLocation: fileLocation,
      s3bucketUrl: signedUrl.data.url,
    }
  }

  async createNewLocationUploadFile(componentState) {
    try {
      const newLocation = await this.createNewLocation(componentState).catch((e) => {
        console.log("Failed to create new location:", e.message);
        throw e;
      });

      const s3BucketUrl = await this.getS3BucketUrl(newLocation.data.uuid).catch((e) => {
        console.log("Failed to get S3 bucket URL:", e.message);
        throw new Error("Failed to get S3 bucket URL");
      });

      await this.uploadFile(s3BucketUrl.data.url, componentState).catch((e) => {
        console.log("Failed to upload file:", e.message);
        throw new Error("Failed to upload file");
      });

      return { ...newLocation.data, s3bucketUrl: s3BucketUrl.data.url }; // Successful upload
    } catch (e) {
      console.log("Failed to createNewLocationUploadFile:", e.message);
      throw e;
    }
  }

  async updateLocationAndUploadFile(componentState) {
    try {
      const updatedLocation = await this.updateLocation(componentState)

      console.log("updatedLocation",updatedLocation)
      if(componentState.fileForS3Upload){
      const signedUrl = await this.getS3BucketUrl(updatedLocation.uuid)
      console.log("signedUrl",signedUrl)
      return await this.uploadFile(signedUrl.data.url, componentState)
      }
      return "success"
    } catch (e) {
      console.log("failed to updateLocationAndUploadFile: ", e.message);
      throw e
    }
  }

  async fetchAll(queryParams) {
    try {
      const res = await this.httpClient.get(this.url, queryParams);
      console.log("response in get request", res)
      if (res && res.results) {
        return res
      }
    } catch (e) {
      console.error("Failed to get MediaFile", e);
    }
    return null;
  }

  async delete(state) {
    const {uuid}= state
    try {
      const url = `${this.url}/${uuid}`;
      const res = await this.httpClient.destroy(url);
      const response = {}
      response.status = res.status
      response.uuid = res.config.url.split("/").pop()
      return response
    } catch (e) {
      console.error("Failed to delete MediaFile", e.message)
      throw e
    }
  }

  async fetchFilters (queryParams) {
    const url = '/sites/filters/mediaFiles'
    try {
      const res = await this.httpClient.get(url, queryParams);
      console.log("response in get request", res)
      if (res) {
        return res
      }
    } catch (e) {
      console.error("Failed to get mediaFiles", e);
    }
    return null;
  }

  async convertEpsToBase64(fileOrUrl, options = {}) {
    try {
      let file;

      if (typeof fileOrUrl === 'string') {
        try {
          file = await this.downloadFileFromURL(fileOrUrl);
        } catch (downloadError) {
          console.error("Failed to download file for EPS conversion:", downloadError.message);
          throw downloadError;
        }
      } else {
        file = fileOrUrl;
      }

      const formData = new FormData();
      formData.append('file', file);

      // Use default options if not provided
      formData.append('quality', options.quality || 90);
      formData.append('density', options.density || 300);
      formData.append('background', options.background || 'white');

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      };
      const response = await this.httpClient.instance.post('/image-conversion/eps-to-base64', formData, config);
      const { base64, mimeType } = response.data.data;
      return `data:${mimeType};base64,${base64}`;  // Return formatted data URL directly

    } catch (e) {
      console.error("Failed to convert EPS to Base64:", e.message);
      throw e;
    }
  }

  async downloadOriginalFile(cdnUrl) {
    try {
      const response = await axios.get(cdnUrl, { responseType: 'blob' });
      return response.data;
    } catch (e) {
      console.error("Failed to download original file from CDN:", e.message);
      throw new Error(`Failed to download file: ${e.message}`);
    }
  }

  // Helper method to download file from S3 URL and convert to File object
  async downloadFileFromURL(imageUrl, filename = 'file.eps') {
    try {
      const response = await axios.get(imageUrl, {
        responseType: 'blob',
      });

      // Extract filename from URL if not provided
      if (filename === 'file.eps') {
        const urlParts = imageUrl.split('/');
        const lastPart = urlParts[urlParts.length - 1];
        if (lastPart && lastPart.includes('.')) {
          filename = lastPart.split('?')[0]; // Remove query parameters
        }
      }

      // Create File object from blob
      const file = new File([response.data], filename, {
        type: 'application/postscript'
      });

      return file;
    } catch (e) {
      console.error("Failed to download file from S3:", e.message);
      throw new Error(`Failed to download file from S3: ${e.message}`);
    }
  }

}

export default MediaFileManager;
